import { Procedure } from '../define-procedure';
import { MessageEnum } from '../models/message.enum';
import { EventsEnum } from 'src/app/engine/models/events.enum';
import { RPCEvent } from '../define-event';
import { HumanInterface } from '../models/human.interface';
import { WebGLInfoModel } from '../models/webgl-info.model';

export interface HumanInfoResponse {
  version: string;
  webglInfo: WebGLInfoModel;
  apiFunctions: string[];
  apiEvents: string[];
}

type HumanProcRequest = void;
type HumanProcResponse = HumanInfoResponse | void;
type HumanEventResponse = void;

export function getHumanEvents(): RPCEvent<HumanEventResponse>[] {
  return [
    {
      eventName: EventsEnum.HumanReady,
      aliasEvents: [EventsEnum.HumanStarted]
    },
    {
      eventName: EventsEnum.Error,
      aliasEvents: [EventsEnum.HumanError],
      mapFn: (err) => err
    }
  ];
}

export function getHumanProcedures(
  human: HumanInterface,
  webglInfo: WebGLInfoModel,
): Procedure<HumanProcRequest, HumanProcResponse>[] {
  return [
    {
      procName: MessageEnum.HumanInfo,
      actionFn: () => {
        return {
          version: human.VERSION,
          webglInfo: webglInfo,
          apiFunctions: human.rpc.getProcedures().sort(),
          apiEvents: human.rpc.getEvents().sort()
        };
      }
    }
  ];
}
